export default "__VITE_PUBLIC_ASSET__2c9491c4__"